module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.9e1e7c5e7f0626a44a06.js");
};